/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ClientDetailOptionsViewModel } from '../models/client-detail-options-view-model';
import { ClientFeatureSwitchViewModel } from '../models/client-feature-switch-view-model';
import { ClientModel } from '../models/client-model';
import { ClientPermissionViewModel } from '../models/client-permission-view-model';
import { ClientRoleViewModel } from '../models/client-role-view-model';
import { ClientSettingViewModel } from '../models/client-setting-view-model';
import { ClientUserRolesViewModel } from '../models/client-user-roles-view-model';
import { ClientUserViewModel } from '../models/client-user-view-model';
import { ClientUserViewModelPrimeDatatableResults } from '../models/client-user-view-model-prime-datatable-results';
import { ClientViewModelPrimeDatatableResults } from '../models/client-view-model-prime-datatable-results';
import { Delete } from '../fn/clients/delete';
import { Delete$Params } from '../fn/clients/delete';
import { Get } from '../fn/clients/get';
import { Get$Params } from '../fn/clients/get';
import { GetClientDetailOptions } from '../fn/clients/get-client-detail-options';
import { GetClientDetailOptions$Params } from '../fn/clients/get-client-detail-options';
import { GetClientFeatures } from '../fn/clients/get-client-features';
import { GetClientFeatures$Params } from '../fn/clients/get-client-features';
import { GetClientLink } from '../fn/clients/get-client-link';
import { GetClientLink$Params } from '../fn/clients/get-client-link';
import { GetClientPermissions } from '../fn/clients/get-client-permissions';
import { GetClientPermissions$Params } from '../fn/clients/get-client-permissions';
import { GetClientRoles } from '../fn/clients/get-client-roles';
import { GetClientRoles$Params } from '../fn/clients/get-client-roles';
import { GetClientSettings } from '../fn/clients/get-client-settings';
import { GetClientSettings$Params } from '../fn/clients/get-client-settings';
import { GetClientUser } from '../fn/clients/get-client-user';
import { GetClientUser$Params } from '../fn/clients/get-client-user';
import { GetClientUserRoles } from '../fn/clients/get-client-user-roles';
import { GetClientUserRoles$Params } from '../fn/clients/get-client-user-roles';
import { GetClientUsers } from '../fn/clients/get-client-users';
import { GetClientUsers$Params } from '../fn/clients/get-client-users';
import { GetClientUsersDataTable } from '../fn/clients/get-client-users-data-table';
import { GetClientUsersDataTable$Params } from '../fn/clients/get-client-users-data-table';
import { GetImpersonationLink } from '../fn/clients/get-impersonation-link';
import { GetImpersonationLink$Params } from '../fn/clients/get-impersonation-link';
import { List } from '../fn/clients/list';
import { List$Params } from '../fn/clients/list';
import { ResetClientUserAccessCredentials } from '../fn/clients/reset-client-user-access-credentials';
import { ResetClientUserAccessCredentials$Params } from '../fn/clients/reset-client-user-access-credentials';
import { Save } from '../fn/clients/save';
import { Save$Params } from '../fn/clients/save';
import { SaveClientFeatureSwitches } from '../fn/clients/save-client-feature-switches';
import { SaveClientFeatureSwitches$Params } from '../fn/clients/save-client-feature-switches';
import { SaveClientPermission } from '../fn/clients/save-client-permission';
import { SaveClientPermission$Params } from '../fn/clients/save-client-permission';
import { SaveClientSettings } from '../fn/clients/save-client-settings';
import { SaveClientSettings$Params } from '../fn/clients/save-client-settings';
import { SaveClientUser } from '../fn/clients/save-client-user';
import { SaveClientUser$Params } from '../fn/clients/save-client-user';
import { SaveClientUserPassword } from '../fn/clients/save-client-user-password';
import { SaveClientUserPassword$Params } from '../fn/clients/save-client-user-password';
import { UploadLogoImage } from '../fn/clients/upload-logo-image';
import { UploadLogoImage$Params } from '../fn/clients/upload-logo-image';

@Injectable({ providedIn: 'root' })
export class ClientsApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiClientsListPost()` */
  static readonly ApiClientsListPostPath = '/api/Clients/List';

  /**
   * List Clients.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `List()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  List$Response(params?: List$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientViewModelPrimeDatatableResults>> {
    return List(this.http, this.rootUrl, params, context);
  }

  /**
   * List Clients.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `List$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  List(params?: List$Params, context?: HttpContext): Observable<ClientViewModelPrimeDatatableResults> {
    return this.List$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientViewModelPrimeDatatableResults>): ClientViewModelPrimeDatatableResults => r.body)
    );
  }

  /** Path part for operation `apiClientsGetPost()` */
  static readonly ApiClientsGetPostPath = '/api/Clients/Get';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Get()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Get$Response(params?: Get$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientModel>> {
    return Get(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Get$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Get(params?: Get$Params, context?: HttpContext): Observable<ClientModel> {
    return this.Get$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientModel>): ClientModel => r.body)
    );
  }

  /** Path part for operation `apiClientsSavePost()` */
  static readonly ApiClientsSavePostPath = '/api/Clients/Save';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Save()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  Save$Response(params?: Save$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientModel>> {
    return Save(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Save$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  Save(params?: Save$Params, context?: HttpContext): Observable<ClientModel> {
    return this.Save$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientModel>): ClientModel => r.body)
    );
  }

  /** Path part for operation `apiClientsDeletePost()` */
  static readonly ApiClientsDeletePostPath = '/api/Clients/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Delete()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Delete$Response(params?: Delete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return Delete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Delete$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Delete(params?: Delete$Params, context?: HttpContext): Observable<void> {
    return this.Delete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiClientsGetClientUsersPost()` */
  static readonly ApiClientsGetClientUsersPostPath = '/api/Clients/GetClientUsers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetClientUsers()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetClientUsers$Response(params?: GetClientUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientUserViewModel>>> {
    return GetClientUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetClientUsers$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetClientUsers(params?: GetClientUsers$Params, context?: HttpContext): Observable<Array<ClientUserViewModel>> {
    return this.GetClientUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientUserViewModel>>): Array<ClientUserViewModel> => r.body)
    );
  }

  /** Path part for operation `apiClientsGetClientUserClientIdClientUserIdGet()` */
  static readonly ApiClientsGetClientUserClientIdClientUserIdGetPath = '/api/Clients/GetClientUser/{clientID}/{clientUserID}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetClientUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetClientUser$Response(params: GetClientUser$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientUserViewModel>> {
    return GetClientUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetClientUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetClientUser(params: GetClientUser$Params, context?: HttpContext): Observable<ClientUserViewModel> {
    return this.GetClientUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientUserViewModel>): ClientUserViewModel => r.body)
    );
  }

  /** Path part for operation `apiClientsGetClientUsersDataTableClientIdPost()` */
  static readonly ApiClientsGetClientUsersDataTableClientIdPostPath = '/api/Clients/GetClientUsersDataTable/{clientID}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetClientUsersDataTable()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  GetClientUsersDataTable$Response(params: GetClientUsersDataTable$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientUserViewModelPrimeDatatableResults>> {
    return GetClientUsersDataTable(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetClientUsersDataTable$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  GetClientUsersDataTable(params: GetClientUsersDataTable$Params, context?: HttpContext): Observable<ClientUserViewModelPrimeDatatableResults> {
    return this.GetClientUsersDataTable$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientUserViewModelPrimeDatatableResults>): ClientUserViewModelPrimeDatatableResults => r.body)
    );
  }

  /** Path part for operation `apiClientsGetClientSettingsPost()` */
  static readonly ApiClientsGetClientSettingsPostPath = '/api/Clients/GetClientSettings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetClientSettings()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetClientSettings$Response(params?: GetClientSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSettingViewModel>> {
    return GetClientSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetClientSettings$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetClientSettings(params?: GetClientSettings$Params, context?: HttpContext): Observable<ClientSettingViewModel> {
    return this.GetClientSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSettingViewModel>): ClientSettingViewModel => r.body)
    );
  }

  /** Path part for operation `apiClientsSaveClientSettingsPost()` */
  static readonly ApiClientsSaveClientSettingsPostPath = '/api/Clients/SaveClientSettings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveClientSettings()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SaveClientSettings$Response(params?: SaveClientSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSettingViewModel>> {
    return SaveClientSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveClientSettings$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SaveClientSettings(params?: SaveClientSettings$Params, context?: HttpContext): Observable<ClientSettingViewModel> {
    return this.SaveClientSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSettingViewModel>): ClientSettingViewModel => r.body)
    );
  }

  /** Path part for operation `apiClientsGetClientFeaturesPost()` */
  static readonly ApiClientsGetClientFeaturesPostPath = '/api/Clients/GetClientFeatures';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetClientFeatures()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetClientFeatures$Response(params?: GetClientFeatures$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientFeatureSwitchViewModel>>> {
    return GetClientFeatures(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetClientFeatures$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetClientFeatures(params?: GetClientFeatures$Params, context?: HttpContext): Observable<Array<ClientFeatureSwitchViewModel>> {
    return this.GetClientFeatures$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientFeatureSwitchViewModel>>): Array<ClientFeatureSwitchViewModel> => r.body)
    );
  }

  /** Path part for operation `apiClientsSaveClientFeatureSwitchesClientIdPost()` */
  static readonly ApiClientsSaveClientFeatureSwitchesClientIdPostPath = '/api/Clients/SaveClientFeatureSwitches/{clientID}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveClientFeatureSwitches()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveClientFeatureSwitches$Response(params: SaveClientFeatureSwitches$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientFeatureSwitchViewModel>>> {
    return SaveClientFeatureSwitches(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveClientFeatureSwitches$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveClientFeatureSwitches(params: SaveClientFeatureSwitches$Params, context?: HttpContext): Observable<Array<ClientFeatureSwitchViewModel>> {
    return this.SaveClientFeatureSwitches$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientFeatureSwitchViewModel>>): Array<ClientFeatureSwitchViewModel> => r.body)
    );
  }

  /** Path part for operation `apiClientsUploadLogoImageClientIdLogoPost()` */
  static readonly ApiClientsUploadLogoImageClientIdLogoPostPath = '/api/Clients/UploadLogoImage/{clientID}/{logo}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `UploadLogoImage()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  UploadLogoImage$Response(params: UploadLogoImage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return UploadLogoImage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `UploadLogoImage$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  UploadLogoImage(params: UploadLogoImage$Params, context?: HttpContext): Observable<void> {
    return this.UploadLogoImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiClientsGetImpersonationLinkPost()` */
  static readonly ApiClientsGetImpersonationLinkPostPath = '/api/Clients/GetImpersonationLink';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetImpersonationLink()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetImpersonationLink$Response(params?: GetImpersonationLink$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return GetImpersonationLink(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetImpersonationLink$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetImpersonationLink(params?: GetImpersonationLink$Params, context?: HttpContext): Observable<string> {
    return this.GetImpersonationLink$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiClientsGetClientLinkClientIdGet()` */
  static readonly ApiClientsGetClientLinkClientIdGetPath = '/api/Clients/GetClientLink/{clientID}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetClientLink()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetClientLink$Response(params: GetClientLink$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return GetClientLink(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetClientLink$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetClientLink(params: GetClientLink$Params, context?: HttpContext): Observable<string> {
    return this.GetClientLink$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiClientsGetClientDetailOptionsClientIdGet()` */
  static readonly ApiClientsGetClientDetailOptionsClientIdGetPath = '/api/Clients/GetClientDetailOptions/{clientID}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetClientDetailOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetClientDetailOptions$Response(params: GetClientDetailOptions$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientDetailOptionsViewModel>> {
    return GetClientDetailOptions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetClientDetailOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetClientDetailOptions(params: GetClientDetailOptions$Params, context?: HttpContext): Observable<ClientDetailOptionsViewModel> {
    return this.GetClientDetailOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientDetailOptionsViewModel>): ClientDetailOptionsViewModel => r.body)
    );
  }

  /** Path part for operation `apiClientsSaveClientUserPasswordClientIdPut()` */
  static readonly ApiClientsSaveClientUserPasswordClientIdPutPath = '/api/Clients/SaveClientUserPassword/{clientID}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveClientUserPassword()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveClientUserPassword$Response(params: SaveClientUserPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return SaveClientUserPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveClientUserPassword$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveClientUserPassword(params: SaveClientUserPassword$Params, context?: HttpContext): Observable<void> {
    return this.SaveClientUserPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiClientsSaveClientUserClientIdPut()` */
  static readonly ApiClientsSaveClientUserClientIdPutPath = '/api/Clients/SaveClientUser/{clientID}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveClientUser()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveClientUser$Response(params: SaveClientUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return SaveClientUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveClientUser$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveClientUser(params: SaveClientUser$Params, context?: HttpContext): Observable<void> {
    return this.SaveClientUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiClientsResetClientUserAccessCredentialsClientIdClientUserIdPost()` */
  static readonly ApiClientsResetClientUserAccessCredentialsClientIdClientUserIdPostPath = '/api/Clients/ResetClientUserAccessCredentials/{clientID}/{clientUserID}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ResetClientUserAccessCredentials()` instead.
   *
   * This method doesn't expect any request body.
   */
  ResetClientUserAccessCredentials$Response(params: ResetClientUserAccessCredentials$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return ResetClientUserAccessCredentials(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ResetClientUserAccessCredentials$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ResetClientUserAccessCredentials(params: ResetClientUserAccessCredentials$Params, context?: HttpContext): Observable<void> {
    return this.ResetClientUserAccessCredentials$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiClientsSaveClientPermissionClientIdPost()` */
  static readonly ApiClientsSaveClientPermissionClientIdPostPath = '/api/Clients/SaveClientPermission/{clientID}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveClientPermission()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveClientPermission$Response(params: SaveClientPermission$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientPermissionViewModel>> {
    return SaveClientPermission(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveClientPermission$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveClientPermission(params: SaveClientPermission$Params, context?: HttpContext): Observable<ClientPermissionViewModel> {
    return this.SaveClientPermission$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientPermissionViewModel>): ClientPermissionViewModel => r.body)
    );
  }

  /** Path part for operation `apiClientsGetClientPermissionsClientIdGet()` */
  static readonly ApiClientsGetClientPermissionsClientIdGetPath = '/api/Clients/GetClientPermissions/{clientID}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetClientPermissions()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetClientPermissions$Response(params: GetClientPermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientPermissionViewModel>>> {
    return GetClientPermissions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetClientPermissions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetClientPermissions(params: GetClientPermissions$Params, context?: HttpContext): Observable<Array<ClientPermissionViewModel>> {
    return this.GetClientPermissions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientPermissionViewModel>>): Array<ClientPermissionViewModel> => r.body)
    );
  }

  /** Path part for operation `apiClientsGetClientRolesClientIdPost()` */
  static readonly ApiClientsGetClientRolesClientIdPostPath = '/api/Clients/GetClientRoles/{clientID}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetClientRoles()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetClientRoles$Response(params: GetClientRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientRoleViewModel>>> {
    return GetClientRoles(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetClientRoles$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetClientRoles(params: GetClientRoles$Params, context?: HttpContext): Observable<Array<ClientRoleViewModel>> {
    return this.GetClientRoles$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientRoleViewModel>>): Array<ClientRoleViewModel> => r.body)
    );
  }

  /** Path part for operation `apiClientsGetClientUserRolesClientIdGet()` */
  static readonly ApiClientsGetClientUserRolesClientIdGetPath = '/api/Clients/GetClientUserRoles/{clientID}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetClientUserRoles()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetClientUserRoles$Response(params: GetClientUserRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientUserRolesViewModel>> {
    return GetClientUserRoles(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetClientUserRoles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetClientUserRoles(params: GetClientUserRoles$Params, context?: HttpContext): Observable<ClientUserRolesViewModel> {
    return this.GetClientUserRoles$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientUserRolesViewModel>): ClientUserRolesViewModel => r.body)
    );
  }

}
